import axios from 'axios';
import * as loadingActions from './loading.js';

export function loadWork() {
  return(dispatch, getState) => {
    dispatch(loadingActions.loadingData(getState().loading));

    axios.get('https://api.qiydaarpratt.com/api/v1/work').then((response)=>{
      dispatch(loadWorkSuccess(response.data));
      dispatch(loadingActions.doneLoadingData(getState().loading));
    });
  }
}

export function loadWorkStart() {
  return {
    type: 'LOAD_WORK_START'
  };
}

export function loadWorkSuccess(work_data) {
  return {
    type: 'LOAD_WORK_SUCCESS',
    payload: work_data
  };
}

export function loadWorkError(error) {
  return {
    type: 'LOAD_WORK_ERROR',
    payload: error
  };
}



// WEBPACK FOOTER //
// ./src/actions/work.js